// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1AU9Q","title":"AfterBackImages_title__1vAM7","images":"AfterBackImages_images__3naJ_"};